import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie';
import { parse } from 'query-string';
import { map, tap, mapTo, catchError, takeUntil } from 'rxjs/operators';
import { Tokens } from '../_models/Token.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CurrentUser {
  private currentUser;

  constructor(private cookieService: CookieService, private http: HttpClient) {
    this.currentUser = this.cookieService.getObject('sc-user');
  }

  public get(): any {
    return this.currentUser;
  }

  refreshToken() {
    return this.http.post<any>(`${environment.API}/token/refresh/`, {
      refresh_token: this.getRefreshToken(),
    })
    .pipe(tap((tokens) => {
        this.storeJwtToken(tokens.access_token);
    }));

  }

  getJwtToken() {
    if (this.currentUser === undefined) {
      return '';

    } else {
      return this.currentUser.access_token;

    }

  }
  getRefreshToken() {
    if (this.currentUser === undefined) {
      return '';

    } else {
      return this.currentUser.refresh_token;
    }
  }

  authenticateUrl(url) {
    const refreshToken = this.getRefreshToken();
    if (url.includes('?')) {
      return `${url}&token=${refreshToken}`;
    } else {
      return `${url}/?token=${refreshToken}`;
    }
  }

  storeJwtToken(access: string) {
    this.currentUser.access_token = access;
    this.cookieService.putObject('sc-user', this.currentUser);
  }

  createUser(): Observable<any>  {
    return this.http.post<any>( environment.API + '/users/register/', {})
    .pipe(
        map(response => {
            response.guest = true;
            return(response);
        }
    ));
  }

  engageUser(): Observable<any> {
    return this.http.put<any>( environment.API + '/users/engage/', {});
  }

  userName(firstName): Observable<any>  {
    return this.http.put<any>( environment.API + '/users/account/',
    {
      'first_name': firstName,
    })
    .pipe(
        map(response => {
            return(response);
        }
    ));
  }


  updateGuest(user) {
    return this.http.post<any>( environment.API + '/users/account/activate/',
    {
      'first_name': user.first_name,
      'last_name': user.last_name,
      'username': user.username,
      'password': user.password,
    })
    .pipe(
        map(response => {
          return(response);
        }
    ));
  }

  acceptShare(invitationToken: string): Observable<any> {
    return this.http.post<any>( environment.API + '/invitations/' + invitationToken + '/accept/', {})
    .pipe(
        map(response => {
          return(invitationToken);
        }
    ));
  }


  public set(user) {
    this.currentUser = user;
    this.cookieService.putObject('sc-user', user);
  }

  public setFirstName(firstName: string) {
    this.currentUser.first_name = firstName;
  }

  public updateCurrentUser(user) {
    this.currentUser.first_name = user.first_name;
    this.currentUser.last_name = user.last_name;
    this.currentUser.email = user.email;
    this.currentUser.guest = false;
    this.cookieService.putObject('sc-user', this.currentUser);
  }

  public getFirstName() {

    if (this.currentUser === undefined) {
      return '';

    } else {
      return this.currentUser.firstName;

    }

  }

  public clear() {
    this.currentUser = undefined;
    this.cookieService.remove('sc-user');
  }
}
